// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e72c93d5","239":"1a38496a","732":"159cb417"}[chunkId] + ".chunk.js";
};